/* istanbul ignore file */
import React from 'react';
import { TimelineLayout, TimelinePageLayout, Timeline } from 'framework/ui/timeline';
import useAssetNoteItem from 'domain/finance/assets/Timeline/note/assetNoteRegistry';
import { Show } from 'framework/show';
import { useAssetId } from 'domain/finance/assets/shared/useAssetRouting';
import AssetHeader from 'domain/finance/assets/shared/AssetHeader';
import AssetMenu from 'domain/finance/assets/shared/AssetMenu';
import AssetTimelineBreadcrumbs from 'domain/finance/assets/Timeline/Breadcrumbs';
import useAssetService from 'domain/finance/assets/useAssetService';
import { ResourceData } from 'framework/crud';

const AssetTimelinePage = () => {
  const assetId = useAssetId();
  const { getById, createTimelineItem, searchTimelineItems, invalidateCache } = useAssetService();

  const noteRegistry = useAssetNoteItem() as any;

  const createTimelineItemMethod = async (itemType: string, request: ResourceData) => {
    const response = (await createTimelineItem(assetId, itemType, request)) as any;

    invalidateCache();

    return response;
  };

  return (
    <Show getDataMethod={() => getById(assetId)}>
      <Timeline
        registries={[noteRegistry]}
        getDataMethod={request => searchTimelineItems(assetId, request)}
        createTimelineItemMethod={createTimelineItemMethod}
        getPageByEntryIdMethod={id =>
          searchTimelineItems(assetId, { pageSize: 30, filter: {}, sort: { createdAt: 'DESC' } })
        }
      >
        <TimelinePageLayout
          menu={<AssetMenu />}
          breadcrumbs={<AssetTimelineBreadcrumbs />}
          entityHeader={<AssetHeader />}
          titleVariant="h4"
        >
          <TimelineLayout noEntriesMessage="No entries in this asset timeline yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default AssetTimelinePage;
